import { Button, SvgCheck, Text } from '@loomhq/lens';
import classnames from 'classnames';
import React, { useRef, useState } from 'react';

import {
  SHARE_MENU_ACTION_EMBED_THUMB,
  SHARE_MENU_ACTION_EMBED_THUMB_HTML,
} from 'constants/events';
import * as analytics from 'utilities/analytics';
import * as clipboard from 'utilities/clipboard';
import {
  getAnimatedPreview,
  getAnimatedPreviewEmbed,
  getShareVideoUrl,
} from 'utilities/video';

import DropdownMenu from 'components/dropdown-menu';

import './styles.less';

export default function EmbedThumbnailDropdown({ video, ...dropdownProps }) {
  const codeNode = useRef();
  const thumbNode = useRef();
  const [showEmbedCode, setShowEmbedCode] = useState(false);
  const [embedCopied, setEmbedCopied] = useState(false);

  const url = getShareVideoUrl(video.id);
  const gif = getAnimatedPreview(video);
  const embedCode = getAnimatedPreviewEmbed(video);

  if (!gif) {
    return null;
  }

  let copyTimeout;
  const onMenuClick = ev => ev.stopPropagation();
  const copyCode = () => selectAndCopyEmbedCode(codeNode);
  const copyThumb = () => selectAndCopyEmbedCode(thumbNode, true);
  const toggleEmbedCodeView = () => setShowEmbedCode(!showEmbedCode);
  const selectAndCopyEmbedCode = (node, asHtml = false) => {
    const embedCopied = clipboard.copy(node.current, { asHtml });

    setEmbedCopied(embedCopied);

    if (copyTimeout) {
      window.clearTimeout(copyTimeout);
      copyTimeout = null;
    }

    copyTimeout = window.setTimeout(() => setEmbedCopied(false), 3000);

    if (embedCopied) {
      analytics.track(
        asHtml
          ? SHARE_MENU_ACTION_EMBED_THUMB
          : SHARE_MENU_ACTION_EMBED_THUMB_HTML
      );
    }
  };

  const containerClassName = classnames('embed-thumbnail', {
    'code-expanded': showEmbedCode,
  });
  const codeClassName = classnames('embed-thumbnail-code', {
    'code-hidden': !showEmbedCode,
  });
  const buttonValue = embedCopied
    ? 'Copied!'
    : showEmbedCode
    ? 'Copy Code'
    : 'Copy Thumbnail';

  const buttonIcon = embedCopied ? <SvgCheck /> : null;

  return (
    <DropdownMenu additionalClass="embed-dropdown" {...dropdownProps}>
      <div className={containerClassName} onClick={onMenuClick}>
        <div className="embed-thumbnail-code-container" onClick={copyCode}>
          <div className={codeClassName} ref={codeNode}>
            <p>{embedCode}</p>
          </div>
        </div>

        <div className="embed-thumbnail-preview-container">
          <Text htmlTag="h3" variant="title">
            Copy Linked GIF
          </Text>
          <div ref={thumbNode} className="embed-thumbnail-preview">
            <a href={url} title="Watch Loom Video">
              <p>
                {video.name} &mdash; Watch Video
                <br />
                <br />
              </p>
              <img style={{ maxWidth: '300px' }} src={gif} />
            </a>
          </div>

          <Button
            hasFullWidth
            icon={buttonIcon}
            variant="primary"
            onClick={showEmbedCode ? copyCode : copyThumb}
          >
            {buttonValue}
          </Button>

          <a className="embed-show-code-button" onClick={toggleEmbedCodeView}>
            {showEmbedCode ? 'Hide Code' : 'Show Code'}
          </a>
        </div>
      </div>
    </DropdownMenu>
  );
}
